export const ADD_IN_POPUP_LIST = 'ADD_IN_POPUP_LIST';
export const REMOVE_POPUP_FROM_LIST = 'REMOVE_POPUP_FROM_LIST';
